var $ = jQuery; 
 
/* Sticky Header
 * Uses hysteresis (two thresholds) to prevent a flicker loop:
 * when .is-scrolled shrinks the header, the document height shrinks
 * too, which can re-cross a single threshold and toggle the class
 * back. The gap between addAt and removeAt creates a dead zone.
 */
(function () {
	var header = document.getElementById('masthead');
	if (!header) return;

	var addAt    = 180; // start showing .is-scrolled at this scrollY
	var removeAt = 80;  // hide .is-scrolled below this scrollY
	var ticking  = false;
	var scrolled = false;

	function update() {
		ticking = false;
		var y = window.scrollY;

		if (!scrolled && y >= addAt) {
			scrolled = true;
			header.classList.add('is-scrolled');
		} else if (scrolled && y <= removeAt) {
			scrolled = false;
			header.classList.remove('is-scrolled');
		}
	}

	window.addEventListener('scroll', function () {
		if (!ticking) {
			window.requestAnimationFrame(update);
			ticking = true;
		}
	}, { passive: true });

	update(); // sync on load (handles refresh mid-page)
})();


/* Stats counter animation
 * Fires when a .stats-counter (data-stats-counter) scrolls into view.
 * Each .stats-counter__number is animated from 0 → data-target with an
 * ease-out curve, then marked .is-counted so it won't replay on
 * subsequent intersections.
 */
(function () {
	var counters = document.querySelectorAll('[data-stats-counter]');
	if (!counters.length) return;

	// Older browsers without IntersectionObserver get the final value
	// rendered immediately — no animation, but the number is correct.
	if (typeof IntersectionObserver === 'undefined') {
		counters.forEach(function (group) {
			group.querySelectorAll('.stats-counter__number').forEach(function (el) {
				el.textContent = formatNumber(parseFloat(el.dataset.target) || 0);
				el.classList.add('is-counted');
			});
		});
		return;
	}

	var DURATION = 1600; // ms — total animation time per group
	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			animateGroup(entry.target);
			observer.unobserve(entry.target);
		});
	}, { threshold: 0.35 });

	counters.forEach(function (group) {
		// Seed the visible text to 0 so the page never flashes the raw
		// target value before the observer fires.
		group.querySelectorAll('.stats-counter__number').forEach(function (el) {
			el.textContent = '0';
		});
		observer.observe(group);
	});

	function animateGroup(group) {
		var nodes = group.querySelectorAll('.stats-counter__number');
		var start = null;

		function step(ts) {
			if (start === null) start = ts;
			var progress = Math.min((ts - start) / DURATION, 1);
			var eased = easeOutQuart(progress);

			nodes.forEach(function (el) {
				var target = parseFloat(el.dataset.target) || 0;
				var current = target * eased;
				// Integer targets stay integers during animation; decimal
				// targets keep one decimal place for a smoother ramp.
				var rounded = Number.isInteger(target) ? Math.round(current) : Math.round(current * 10) / 10;
				el.textContent = formatNumber(rounded);
			});

			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				nodes.forEach(function (el) {
					el.classList.add('is-counted');
				});
			}
		}

		requestAnimationFrame(step);
	}

	function easeOutQuart(t) {
		return 1 - Math.pow(1 - t, 4);
	}

	function formatNumber(n) {
		// Thousands separators (e.g. 12,000) — kept locale-aware so it
		// matches the visitor's region.
		return n.toLocaleString();
	}
})();



$(document).on('click', 'a[href^="#"]', function (event) {
	event.preventDefault();

	$('html, body').animate({
		scrollTop: $($.attr(this, 'href')).offset().top - 100
	}, 500);
});

/* FANCYBOX */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.Fancybox === 'undefined') {
        return;
    }

    Fancybox.bind('[data-fancybox]');
});

/* LAZY LOAD VIDEO */
document.addEventListener("click", function(e) {
  if (e.target.closest(".lazy-video")) {
    const wrapper = e.target.closest(".lazy-video");
    const src = wrapper.dataset.src + "?autoplay=1&rel=0&showinfo=0";
    wrapper.innerHTML = `<iframe src="${src}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen loading="lazy"></iframe>`;
  }
});

